import todoService from "../services/todo.service";
import { SET_TODO_LIST, START_LOADER, STOP_LOADER } from "./types";

export const getTodolistAction = (page, perPage, search, selectedUser) => (dispatch) => {
    dispatch({ type: START_LOADER });
    return todoService.getTodolist(page, perPage, search, selectedUser).then((resp) => {
        if (resp.status) {
            dispatch({
                type: SET_TODO_LIST,
                payload: resp.data,
                count: resp.count,
            });
        } else {
            dispatch({ type: SET_TODO_LIST, payload: [] });
        }
        dispatch({ type: STOP_LOADER });
    });
};

export const addTodoAction = (payload, selectedUser) => (dispatch) => {
    dispatch({ type: START_LOADER });
    return todoService.addTodo(payload, selectedUser).then((resp) => {
        if (resp.status) {
          
        } else {
        }
        dispatch({ type: STOP_LOADER });
    });
};